import script from "./loading.vue?vue&type=script&setup=true&lang=js"
export * from "./loading.vue?vue&type=script&setup=true&lang=js"

import "./loading.vue?vue&type=style&index=0&id=6d4004f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4004f2"]])

export default __exports__